import Footer from "./Footer"
import { useLogout } from "./Logout"
import { NavLink } from "react-router-dom"
import {
  LayoutDashboard,
  Building2,
  Users,
  Wrench,
  CreditCard,
  User,
  LucideLogOut,
  LucideUser,
  House,
  Banknote,
  Building,
  Coins,
  LucideMail,
} from "lucide-react"

export default function Sidebar({ onNavigate }) {
  const logout = useLogout()

  return (
    <aside className="h-full w-64 bg-slate-900 text-slate-200 shadow-xl flex flex-col">
      <div className="flex items-center gap-3 px-6 py-5 border-b border-slate-800">
        <a href="/">
          <img
            className="h-12 object-contain"
            src="/images/icons/STAY-SUITE_LOGO-V1.webp"
            alt="Logo"
          />
        </a>
      </div>

      <nav className="flex-1 px-3 py-6 space-y-1 text-sm">
        {/* <SidebarItem label="Dashboard" to="/dashboard" onClick={onNavigate} /> */}
        <SidebarItem label="Floor Units" to="/units" onClick={onNavigate} />
        <SidebarItem label="Rooms" to="/rooms" onClick={onNavigate} />
        <SidebarItem label="Tenant" to="/tenant" onClick={onNavigate} />
        <SidebarItem label="Billing" to="/billing" onClick={onNavigate} />
        {/* <SidebarItem label="Utilities" to="/utilities" onClick={onNavigate} /> */}
        <SidebarItem label="Email" to="/send-email" onClick={onNavigate} />
        <SidebarItem label="Profile" to="/profile" onClick={onNavigate} />
        <SidebarItem label="Floor Map" to="/floor-map" onClick={onNavigate} />
      </nav>

      <div className="px-6 py-4 border-t border-slate-800 text-sm">
        <button onClick={logout} className="flex items-center gap-2">
          <LucideLogOut />
          Logout
        </button>
      </div>

      <Footer />
    </aside>
  )
}

function SidebarItem({ label, to, onClick }) {
  const iconMap = {
    Dashboard: LayoutDashboard,
    "Floor Units": Building2,
    Residents: Users,
    Maintenance: Wrench,
    Billing: Banknote,
    Utilities: Coins,
    Email: LucideMail,
    // User: User2,
    Tenant: User,
    Profile: LucideUser,
    Rooms: House,
    "Floor Map": Building,
  }

  const Icon = iconMap[label]

  return (
    <NavLink to={to} onClick={onClick}>
      {({ isActive }) => (
        <div
          className={`
            group w-full flex items-center gap-3 px-4 py-2.5 rounded-xl
            text-sm font-medium transition-all mb-2
            ${
              isActive
                ? "bg-orange-500 text-white shadow-md"
                : "text-slate-300 hover:bg-slate-800 hover:text-white"
            }
          `}
        >
          {Icon && (
            <Icon
              size={18}
              className={
                isActive
                  ? "text-white"
                  : "text-slate-400 group-hover:text-white"
              }
            />
          )}
          <span className="flex-1 text-left">{label}</span>
        </div>
      )}
    </NavLink>
  )
}
